import React, { useState, useRef, useEffect } from "react";
import { FilterProps, FiltersSelected } from "@usereactify/search";
import ReactSlider from "react-slider";
export type Props = React.ComponentProps<NonNullable<FilterProps["renderFilterSlider"]>>;
export type FilterSliderProps = {
  reactifyProps: Props;
  onClick: (arg0: string) => void;
  openFilter: string;
};
import { useOnClickOutside } from "../../../hooks/useOnClickOutside";

export const FilterSlider: React.FC<FilterSliderProps> = ({ reactifyProps }) => {
  const [open, setOpen] = useState<boolean>(false);
  const filterClasses = `thb-filter-dropdown ${open ? "active-facets" : ""}`;

  const ref = useRef(null);
  useOnClickOutside(ref, () => setOpen(false));

  const handleOpen = () => {
    setOpen((prev) => !prev);
  };

  useEffect(() => {
    // listen for the esc key and close the filter
    const handleEsc = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        setOpen(false);
      }
    };

    if (window) {
      window.addEventListener("keydown", handleEsc);
    }

    return () => {
      if (window) {
        window.removeEventListener("keydown", handleEsc);
      }
    }
  }, []);

  return (
    <div ref={ref} className="facets">
      <div className="thb-filter">
        <button onClick={handleOpen} className="">
          <span className="thb-filter-title">
            {reactifyProps?.filter?.name}
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M20 8L12 16L4 8"
                stroke="#2B2B2B"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>
        </button>
        <div className={filterClasses}>
          <div className="thb-filter-dropdown__inner">
            <ReactSlider
              {...reactifyProps.filterSliderProps.reactSliderProps}
              className="horizontal-slider"
              thumbClassName="slider-thumb"
              trackClassName="slider-track"
              renderThumb={(props) => (
                <div {...props}>
                  <div className="bar"></div>
                  <div className="bar"></div>
                  <div className="bar"></div>
                </div>
              )}
            />
            <FiltersSelected render={(props) => <SelectedPriceValues {...props} />} />
          </div>
        </div>
      </div>
    </div>
  );
};

const SelectedPriceValues: React.FC<SelectedPriceValuesProps> = ({ selectedFilters }) => {
  const priceArr = selectedFilters?.filter((filter: SelectedFilterProps) => filter?.key === "price");

  return (
    <div className="price-value-container">
      {priceArr[0]?.value?.map((v: string) => (
        <div className="price-value">
          <span>{`$`}</span>
          <div className="price-value-field">{v}</div>
        </div>
      ))}
    </div>
  );
};

type SelectedPriceValuesProps = {
  selectedFilters: SelectedFilterProps[];
  handleRemove: (filterKey: string) => void;
};
type SelectedFilterProps = {
  key: string;
  label: string;
  value:
    | string
    | string[]
    | {
        start: number;
        end: number;
      };
};
